var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnLikeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1467 0C10.6406 0 9.32198 0.647653 8.50001 1.74239C7.67805 0.647653 6.3594 0 4.85332 0C3.65445 0.00135127 2.50507 0.478198 1.65735 1.32593C0.809619 2.17365 0.332772 3.32303 0.331421 4.5219C0.331421 9.62727 7.90123 13.7597 8.22359 13.9304C8.30856 13.9761 8.40353 14 8.50001 14C8.59649 14 8.69147 13.9761 8.77643 13.9304C9.0988 13.7597 16.6686 9.62727 16.6686 4.5219C16.6673 3.32303 16.1904 2.17365 15.3427 1.32593C14.495 0.478198 13.3456 0.00135127 12.1467 0ZM8.50001 12.7488C7.16824 11.9728 1.49836 8.43772 1.49836 4.5219C1.49952 3.63247 1.85336 2.77979 2.48229 2.15087C3.11121 1.52194 3.96389 1.1681 4.85332 1.16694C6.27188 1.16694 7.46289 1.92254 7.9603 3.13616C8.00426 3.24317 8.07904 3.3347 8.17514 3.39912C8.27124 3.46353 8.38432 3.49793 8.50001 3.49793C8.6157 3.49793 8.72879 3.46353 8.82488 3.39912C8.92098 3.3347 8.99576 3.24317 9.03972 3.13616C9.53713 1.92035 10.7281 1.16694 12.1467 1.16694C13.0361 1.1681 13.8888 1.52194 14.5177 2.15087C15.1467 2.77979 15.5005 3.63247 15.5017 4.5219C15.5017 8.43188 9.83033 11.9721 8.50001 12.7488Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnLikeHeart);
export default __webpack_public_path__ + "static/media/unLikeHeart.3d6a124e6326a462ed2daafce415b453.svg";
export { ForwardRef as ReactComponent };